import { ADMIN_SYNC_JOBS, type AdminSyncJob, type AdminSyncJobId } from '@sea-snag/shared';
import { useMutation, useQuery } from '@tanstack/react-query';

import { adminApi } from '../lib/api-client';
import { queryKeys, STALE_TIMES } from '../lib/query-keys';

export function useAdminJobs() {
  return useQuery({
    queryKey: queryKeys.admin.jobs(),
    queryFn: adminApi.listJobs,
    staleTime: STALE_TIMES.LONG,
    initialData: ADMIN_SYNC_JOBS as AdminSyncJob[],
  });
}

export function useRunAdminJob() {
  return useMutation({
    mutationFn: (id: AdminSyncJobId) => adminApi.runJob(id),
  });
}
